import createIcon from '../../createIcon';

/**
 * @component @name NavigateNext
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNOS43MDQ5MiA2TDguMjk0OTIgNy40MUwxMi44NzQ5IDEyTDguMjk0OTIgMTYuNTlMOS43MDQ5MiAxOEwxNS43MDQ5IDEyTDkuNzA0OTIgNloiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const NavigateNext = createIcon('NavigateNext', [
  [
    'path',
    {
      d: 'M9.70492 6L8.29492 7.41L12.8749 12L8.29492 16.59L9.70492 18L15.7049 12L9.70492 6Z',
      key: 'xcu7tv',
    },
  ],
]);

export default NavigateNext;
